<template>
    <div class="container-fluid">
        <!-- breadbrumb -->
        <app-breadcrumb pageTitle="Categories"></app-breadcrumb>

        <!-- Alert Messages -->
        <dl v-if="msg !== ''" class="row mb-n2">
            <dd class="col-12">
                <div :class="`alert alert-${color} text-center p-1`" role="alert">
                    <i class="fas fa-exclamation-circle"></i> {{ msg }}
                </div>
            </dd>
        </dl>

        <!-- page heading -->
        <div class="row mb-2">
            <div class="col-lg-9 col-md-8 col-sm-6 col-12">
                <p><span class="h3 md-small-text">Categories</span> <br> <span class="d-none d-md-block">(manage items category and sub-categories here)</span></p>
            </div>
            <div class="col-lg-3 col-md-4 col-sm-6 col-12 text-right">
                <button @click="showNewCategory = !showNewCategory" class="btn btn-warning form-control">
                    <span v-if="showNewCategory"><i class="fas fa-minus-circle"></i> Close Category</span>
                    <span v-else><i class="fas fa-plus-circle"></i> New Category</span>
                </button>
            </div>
        </div>
        
        <!-- import new category -->
        <app-new-category v-if="showNewCategory"></app-new-category>

        <!-- available categories -->
        <div class="row">
            <div class="col-12">
                <!-- display category logs -->
                <div class="table-responsive">
                    <table class="table table-hover mt-3">
                        <thead class="bg-silver">
                            <tr>
                                <th scope="col">No.</th>
                                <th scope="col">Categories</th>
                                <th scope="col" class="text-center">SubCategories</th>
                                <th scope="col" class="text-center">Items</th>
                                <th scope="col">Created</th>
                            </tr>
                        </thead>
                        <tbody v-if="theMainCategories">
                            <tr v-for="(category, i) in theMainCategories" :key="category.id">
                                <th scope="row">{{ i+1 }}.</th>
                                <td>
                                    <router-link :to="{ name: 'manage-category', params: { categoryName: category.category, categoryId: category._id } }" 
                                        class="text-truncate d-block">
                                        {{category.category | capitalize}} 
                                    </router-link>
                                </td>
                                <td class="text-center">{{category.subCategoriesCount}}</td>
                                <td class="text-center">{{category.itemsCount}}</td>
                                <td><span class="text-truncate">{{category.joined | moment("MMM DD 'YY")}}</span></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import Breadcrumb from '../shared/Breadcrumb.vue'
import LayoutShop from '@/layouts/Shop.vue'
import NewCategory from './categoriesParts/NewCategory.vue'

export default {
    name: "MainCategories",
    data() {
        return {
            msg: '',
            color: 'danger',
            showNewCategory: false,
        }
    },
    methods: {
        ...mapActions(['fetchMainCategoriesAction']),
        fetchMainCategoriesFxn() {
            if(this.theMainCategories.length) return
            this.fetchMainCategoriesAction().then(() => {}).catch((e) => {})
        }
    },
    computed: {
        ...mapGetters(['setMainCategories']),
        theMainCategories(){
            if(this.setMainCategories){
                return this.setMainCategories
            }
            return [] 
        },
    },
    components: {
        appBreadcrumb: Breadcrumb,
        appNewCategory: NewCategory
    },
    created() {
        this.fetchMainCategoriesFxn()
        this.$emit('update:layout', LayoutShop);
    }
}
</script>